export function PersonXIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.605 6.5c0 3.038-3 5.5-5 5.5s-5-2.462-5-5.5 2.239-5.5 5-5.5c2.762 0 5 2.462 5 5.5zm-2 0c0 .852-.43 1.745-1.16 2.472-.776.771-1.548 1.028-1.84 1.028-.291 0-1.063-.257-1.839-1.028-.73-.727-1.16-1.62-1.16-2.472 0-2.117 1.517-3.5 3-3.5 1.481 0 3 1.383 3 3.5z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.619 13c.289 0 .575.02.858.057a6 6 0 11.05 7.943H4.605a1.603 1.603 0 01-1.565-1.951l.302-1.359A5.988 5.988 0 019.187 13h2.432zm-2.432 2h2.154A5.99 5.99 0 0011 17c0 .701.12 1.374.341 2H5.098l.195-.876A3.99 3.99 0 019.187 15zm10.641-.828a1 1 0 010 1.414L18.414 17l1.414 1.414a1 1 0 11-1.414 1.414L17 18.414l-1.414 1.414a1 1 0 01-1.414-1.414L15.586 17l-1.414-1.414a1 1 0 111.414-1.414L17 15.586l1.414-1.414a1 1 0 011.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
